import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import { makeStyles } from '@material-ui/core/styles';
import impactCover from '../../assets/cover/impact_cover.webp';
import { Parallax } from 'react-parallax';

const useStyles = makeStyles((theme) => ({
  headerImage: {
    height: '50vh',
    minHeight: '40rem',
    [theme.breakpoints.down('xs')]: {
      minHeight: '30rem',
      height: '30rem',
    }
  },
  title: {
    color: 'white',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1rem',
    },
  },
  subTitle: {
    fontSize: '5rem',
    color: 'white',
    [theme.breakpoints.down('md')]: {
      fontSize: '4rem',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '2rem',
    },
  },
  paper: {
    backgroundColor: 'transparent',
    padding: theme.spacing(4),
  }
}));

const Header = () => {
  const classes = useStyles();

  return (
    <>
      <Parallax
        bgImage={(impactCover)}
        bgImageAlt="the dog"
        strength={-300}
      >
        <Grid
          align="center"
          alignContent="center"
          alignItems="center"
          className={classes.headerImage}
          component="header"
          container
          direction="column"
          justify="center"
          maxWidth="false"
        >
          <Paper
            className={classes.paper}
            elevation={0}
          >
            <Typography
              className={classes.title}
              component="h1"
              style={{color: 'white'}}
              variant="h1"
            >
          Participez à la <br /><span className={classes.subTitle}>reforestation</span> 
            </Typography>
            <Typography
              component="p"
              style={{color: 'white', fontWeight: 'bold'}}
              variant="body2"
            >
          En jouant à SeedOut Fenua, un arbre virtuel qui <br />atteint le stade adulte est un arbre réel qui prend vie.
            </Typography>
          </Paper>
        </Grid>
      </Parallax>
    </>
  );
}

export default Header;
